import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "z-1" }
const _hoisted_2 = ["data-variant"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["f-nav navbar", _ctx.navClasses]),
      "data-variant": _ctx.variant
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.containerClass)
      }, [
        _renderSlot(_ctx.$slots, "brand", {}, undefined, true),
        _renderSlot(_ctx.$slots, "center", {}, undefined, true),
        _renderSlot(_ctx.$slots, "actions", {}, undefined, true),
        _renderSlot(_ctx.$slots, "drawer", {}, undefined, true)
      ], 2)
    ], 10, _hoisted_2)
  ]))
}